/**
 * Demo keyword list for the landing SearchPlayground.
 * Must match apps/api/src/services/demo.ts DEMO_KEYWORDS exactly.
 */
/** Keep in lockstep with apps/api/src/services/demo.ts, five chips is enough. */
export const DEMO_KEYWORDS = [
    'iphone 15 pro',
    'rtx 4090',
    'pokemon charizard psa 10',
    'nintendo switch oled',
    'carhartt detroit jacket',
] as const;

export type DemoKeyword = (typeof DEMO_KEYWORDS)[number];
